<!--安全中心-->
<template>
    <div>
        <div class="py-head">
            <div class="bit-center-wrap ph-cn">
                <div :class="index_tab == 1 ? 'pc-item pc-iActive' : 'pc-item'" @click="changeIndex(1)">概况</div>
                <div :class="index_tab == 2 ? 'pc-item pc-iActive' : 'pc-item'" @click="changeIndex(2)">币币</div>
                <div :class="index_tab == 3 ? 'pc-item pc-iActive' : 'pc-item'" @click="changeIndex(3)">交割合约</div>
                <div :class="index_tab == 4 ? 'pc-item pc-iActive' : 'pc-item'" @click="changeIndex(4)">永续合约</div>
                <div :class="index_tab == 5 ? 'pc-item pc-iActive' : 'pc-item'" @click="changeIndex(5)">理财</div>
            </div>
        </div>
        <div class="bit-center-wrap ph-cn">
            <div style="width: 100%;">
                <div v-if="[1].includes(index_tab)" class="top-model top-bg1">
                    <div>
                        <div class="top-model-head ">
                            <span class="top-model-title">账户总资产 </span>
                            <img class="yj" src="@/assets/img-pc/change_6.png" />
                        </div>
                        <div class="usdt-money">
                            <div class="um-nul"> 99073.2004 </div>
                        </div>
                        <div class="money2">≈$ 99073.2004 </div>
                        <div class="today-money"> 今日收益: 0<i class="el-icon-refresh-right"></i></div>
                    </div>
                </div>

                <div v-if="[1, 2].includes(index_tab)" class="top-model top-bg2">
                    <div>
                        <div class="top-model-head ">
                            <span class="top-model-title">币币账户资产 </span>
                        </div>
                        <div class="usdt-money">
                            <div class="um-nul"> 99073.2004 </div>
                        </div>
                        <div class="money2">≈$ 99073.2004 </div>
                        <div class="today-money"> 今日收益: 0<i class="el-icon-refresh-right"></i></div>
                    </div>
                    <div v-if="![1].includes(index_tab)" class="dsfd" style="">
                        <div class="un-butt">
                            <div class="un-item" @click="$nav.go('/pc/withdrawDeposit')">提币 </div>
                            <div class="un-item un-item2" @click="$nav.go('/pc/deposit')">充币 </div>
                            <div class="un-item" @click="dialogVisible = true">闪兑</div>
                        </div>
                    </div>
                </div>


                <div v-if="[1, 3].includes(index_tab)" class="top-model top-bg3">
                    <div>
                        <div class="top-model-head ">
                            <span class="top-model-title">交割合约账户资产 </span>
                        </div>
                        <div class="usdt-money">
                            <div class="um-nul"> 99073.2004 </div>
                        </div>
                        <div class="money2">≈$ 99073.2004 </div>
                        <div class="today-money"> 今日收益: 0<i class="el-icon-refresh-right"></i></div>
                    </div>
                    <div v-if="![1].includes(index_tab)" class="dsfd" style="">
                        <div class="un-butt">
                            <div class="un-item" @click="dialogVisible1 = true">划入 </div>
                            <div class="un-item un-item2" style="background: rgb(164, 147, 236);">转出 </div>
                        </div>
                    </div>
                </div>

                <div v-if="[1, 4].includes(index_tab)" class="top-model top-bg4">
                    <div>
                        <div class="top-model-head ">
                            <span class="top-model-title">永续合约账户资产 </span>
                        </div>
                        <div class="usdt-money">
                            <div class="um-nul"> 99073.2004 </div>
                        </div>
                        <div class="money2">≈$ 99073.2004 </div>
                        <div class="today-money"> 今日收益: 0<i class="el-icon-refresh-right"></i></div>
                    </div>
                    <div v-if="![1].includes(index_tab)" class="dsfd" style="">
                        <div class="un-butt">
                            <div class="un-item">划入 </div>
                            <div class="un-item un-item2" style="background: rgb(38, 156, 135);">转出 </div>
                        </div>
                    </div>
                </div>

                <div v-if="[1, 5].includes(index_tab)" class="top-model top-bg5">
                    <div>
                        <div class="top-model-head ">
                            <span class="top-model-title">理财账户资产 </span>
                        </div>
                        <div class="usdt-money">
                            <div class="um-nul"> 99073.2004 </div>
                        </div>
                        <div class="money2">≈$ 99073.2004 </div>
                        <div class="today-money"> 今日收益: 0<i class="el-icon-refresh-right"></i></div>
                    </div>
                    <div v-if="![1].includes(index_tab)" class="dsfd" style="">
                        <div class="un-butt">
                            <div class="un-item">划入 </div>
                            <div class="un-item un-item2" style="background: rgb(166, 166, 166);">转出 </div>
                        </div>
                    </div>
                </div>

                <div v-if="![1].includes(index_tab)" class="MetaTrader5-bottom-content">
                    <div class="trend-head">
                        <div class="column"> 币种 </div>
                        <div class="column"> 可用 </div>
                        <div class="column"> 冻结 </div>
                        <div class="column"> 折合(USDT) </div>
                    </div>
                    <div class="scroll-wrap">
                        <ul class="trend-body">
                            <li class="row">
                                <div class="column"> 币种 </div>
                                <div class="column"> 可用 </div>
                                <div class="column"> 冻结 </div>
                                <div class="column"> 折合(USDT) </div>
                            </li>
                        </ul>
                    </div>

                    <div class="bottom-more">没有更多了</div>
                </div>
            </div>
        </div>
        <Recharge :visible.sync="dialogVisible"></Recharge>
        <CommonRecharge :visible.sync="dialogVisible1"></CommonRecharge>
    </div>
</template>
<script>
import Recharge from './components/Recharge.vue';
import CommonRecharge from './components/CommonRecharge.vue';
export default {
    components: {
        Recharge,
        CommonRecharge
    },
    data() {
        return {
            index_tab: 1,
            dialogVisible: false,
            dialogVisible1: true,
        };
    },
    mounted() {

    },
    beforeUnmount() { },
    methods: {
        changeIndex(i) {
            this.index_tab = i
        }
    },
};
</script>
<style lang="scss" scoped>
.py-head {
    background: #090d13;
}

.ph-cn {
    display: flex;
    font-size: 18px;

    .pc-item {
        margin-right: 88px;
        padding: 32px 0;
        cursor: pointer;
    }

    .pc-iActive {
        color: #fff;
        font-weight: 700;
        border-bottom: 3px solid #f0c163;
    }
}

.bit-center-wrap {
    width: 1360px;
    max-width: 90%;
    margin: 0 auto;
}

.top-model {
    padding: 26px 26px 20px 20px;
    margin-top: 26px;
    color: #fff;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;

    .dsfd {
        margin-left: 64px;

        .un-butt {
            display: flex;
            margin-left: 0;
            margin-top: 16px;

            .un-item {
                width: 96px;
                height: 48px;
                font-size: 16px;
                line-height: 48px;
                margin-right: 10px;
                font-weight: 400;
                color: #fff;
                text-align: center;
                cursor: pointer;
                position: relative;
                z-index: 9;
                background: hsla(0, 0%, 100%, .1);
                border: 1px solid #fff;
                border-radius: 5px;
            }

            .un-item2 {
                background: #fdd786;
                border-color: transparent;
            }
        }
    }
}

.top-bg1 {
    background: url("~@/assets/img-pc/change_1.png");
    background-size: cover;
    background-repeat: no-repeat;
}

.top-bg2 {
    background: url("~@/assets/img-pc/change_2.png");
    background-size: cover;
    background-repeat: no-repeat;
}

.top-bg3 {
    background: url("~@/assets/img-pc/change_3.png");
    background-size: cover;
    background-repeat: no-repeat;
}

.top-bg4 {
    background: url("~@/assets/img-pc/change_4.png");
    background-size: cover;
    background-repeat: no-repeat;
}

.top-bg5 {
    background: url("~@/assets/img-pc/change_5.png");
    background-size: cover;
    background-repeat: no-repeat;
}

.top-model-head {
    display: flex;
    align-items: center;
}

.top-model-title {
    font-size: 16px;
    font-weight: 400;
    opacity: .8;
    margin-right: 12px;
}

.yj {
    cursor: pointer;
    width: 20px;
    height: 20px;
    margin-right: 15px;
}

.usdt-money {
    font-weight: 700;
    font-size: 36px;
    margin-top: 20px;
    display: flex;
    font-family: PingFangSC-Regular, "\5FAE\8F6F\96C5\9ED1", sans-serif;
}

.money2 {
    font-size: 14px;
    opacity: .8;
}

.today-money {
    font-size: 14px;
    margin-top: 10px;
}

.MetaTrader5-bottom-content {
    text-align: left;
    min-height: 250px;
    margin-top: 32px;


    .trend-head {
        height: 45px;
        line-height: 45px;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 2px;
        color: #909399;
        background-color: #1c222c;
        padding-left: 20px;

        .column {
            flex: 1;
        }
    }

    .scroll-wrap {
        .trend-body {
            .row {
                display: flex;
                align-items: center;
                justify-content: start;
                margin-bottom: 2px;
                font-size: 16px;
                padding-left: 20px;
            }

            .column {
                flex: 1;
                min-height: 69px;
                display: flex;
                align-items: center;
                justify-content: start;
            }
        }

        ol,
        ul {
            list-style: none;
        }
    }

    .bottom-more {
        width: 100%;
        height: 100px;
        line-height: 100px;
        text-align: center;
        color: #888;
    }
}
</style>